var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useQuery } from '@apollo/client';
import { useAccount } from 'shared/domains/users';
import { GetEsigningCreditsDocument } from './query.gql';
export const useEsigningCredits = () => {
    var _a;
    const account = useAccount();
    const companyId = (_a = account.data) === null || _a === void 0 ? void 0 : _a.companyId;
    const _b = useQuery(GetEsigningCreditsDocument, {
        variables: { companyId },
        fetchPolicy: 'network-only',
    }), { data } = _b, rest = __rest(_b, ["data"]);
    const { available: availableCredits = 0, used: usedCredits = 0 } = (data === null || data === void 0 ? void 0 : data.esigningCredits) || {};
    return Object.assign(Object.assign({}, rest), { availableCredits, usedCredits });
};
